module.exports = __webpack_public_path__ + "assets/icons/ic_refresh_24px.svg";